import { downloadInstaller } from '../../../../api/commonApi'

const DESKTOP_AGENT_INSTALLER = 'MIRAInstaller'
const DEFAULT_INSTALLER_FILENAME = 'MIRAInstaller.zip'

type DownloadInstallerResponse = {
  data: BlobPart
  headers?: Record<string, string | undefined>
}

const getInstallerFileName = (contentDisposition?: string) => {
  if (!contentDisposition || !contentDisposition.includes('filename=')) {
    return DEFAULT_INSTALLER_FILENAME
  }

  const match = contentDisposition.match(/filename="?([^"]+)"?/)
  return match?.[1]
    ? decodeURIComponent(match[1])
    : DEFAULT_INSTALLER_FILENAME
}

export const downloadDesktopAgentInstaller = async () => {
  const response = (await downloadInstaller(
    DESKTOP_AGENT_INSTALLER
  )) as DownloadInstallerResponse
  const fileName = getInstallerFileName(
    response.headers?.['content-disposition']
  )
  const blob = new Blob([response.data])
  const url = window.URL.createObjectURL(blob)
  const anchor = document.createElement('a')

  anchor.href = url
  anchor.download = fileName
  document.body.appendChild(anchor)
  anchor.click()
  anchor.remove()
  window.URL.revokeObjectURL(url)
}
